import React from 'react';
export function SocialProofBar() {
  const items = ['★★★★★ «Por fin algo que funciona» — María, CDMX', '★★★★★ «Mi semana cambió completamente» — Ana, Bogotá', '★★★★★ «Ya no peleo con la cena» — Laura, Buenos Aires', '★★★★★ «Lo mejor que he comprado» — Carmen, Lima', '847+ mamás organizadas', '4.9/5 satisfacción', '★★★★★ «Simple y efectivo» — Sofía, Santiago', '★★★★★ «Adiós al estrés de las 6pm» — Patricia, Madrid'];
  return <div className="bg-slate-900 border-y border-slate-800 py-3 overflow-hidden relative z-20" data-id="element-371">
      <div className="flex whitespace-nowrap animate-marquee hover:[animation-play-state:paused]" data-id="element-372">
        {[...items, ...items, ...items].map((item, index) => <span key={index} className="text-slate-400 text-sm font-medium mx-8 inline-flex items-center" data-id="element-373">
            {item}
          </span>)}
      </div>
    </div>;
}